var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinkedin = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 26,
    fill: "none",
    viewBox: "0 0 27 26",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    fillRule: "evenodd",
    stroke: "#22262A",
    strokeWidth: 1.224,
    d: "M13.4 25c6.628 0 12-5.373 12-12s-5.372-12-12-12c-6.627 0-12 5.373-12 12s5.373 12 12 12Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#22262A",
    d: "M10.145 18.22H7.65v-8.034h2.495zm-1.25-9.13a1.457 1.457 0 0 1-1.02-2.48 1.445 1.445 0 0 1 2.466 1.022c0 .798-.648 1.459-1.445 1.459m10.586 9.13h-2.49v-3.91c0-.933-.018-2.128-1.296-2.128-1.297 0-1.496 1.012-1.496 2.06v3.978h-2.492v-8.034H14.1v1.096h.034c.333-.631 1.147-1.297 2.36-1.297 2.525 0 2.99 1.662 2.99 3.822v4.413z"
  })));
};
export default SvgLinkedin;